export default __webpack_public_path__ + "static/versamel-95e4569524c04b88b13948b1d38e8444.png";